import styled from "styled-components";
import { colors } from "../constants/Colors";

const Features = ({ data = [], productTitle }) => {
  if (!Array.isArray(data) || data.length === 0) return null;

  return (
    <Section aria-labelledby="features-heading">
      <Container>
        <Header>
          <Title id="features-heading">Key Features of {productTitle}</Title>
        </Header>

        <CardsGrid>
          {data.map((item, idx) => {
            const Icon = item.icon;
            return (
              <Card key={item.title ?? idx}>
                <CardBody>
                  {Icon && (
                    <IconWrap aria-hidden="true">
                      <Icon size={22} />
                    </IconWrap>
                  )}
                  <CardTitle>{item.title}</CardTitle>
                  {item.description && <CardDesc>{item.description}</CardDesc>}
                </CardBody>

                {item.image && (
                  <MediaWrap>
                    <img src={item.image} alt={item.title + ' illustration'} loading="lazy" />
                  </MediaWrap>
                )}
              </Card>
            );
          })}
        </CardsGrid>
      </Container>
    </Section>
  );
};

export default Features;


/* ------------------ styles ------------------ */

const Section = styled.section`
  padding: 64px 20px;
  background: #f9fafb;
`;

const Container = styled.div`
  margin: 0 auto;
  max-width: 1200px;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 40px;
`;

const Title = styled.h2`
  font: 800 32px/1.2 Inter, system-ui, sans-serif;
  margin: 0;
  color: #111827;
`;

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.article`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  padding: 20px;
  border-radius: 16px;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 20px;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const IconWrap = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #f3f4f6;
  color: ${colors.PRIMARY_PURPLE};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;

  svg {
    display: block;
  }
`;

const CardBody = styled.div`
  display: grid;
  gap: 12px;
`;

const CardTitle = styled.h3`
  margin: 0;
  font: 700 18px/1.4 Inter, system-ui, sans-serif;
  color: #111827;
`;

const CardDesc = styled.p`
  margin: 0;
  color: #4b5563;
  font: 500 14px/1.6 Inter, system-ui, sans-serif;
`;

const MediaWrap = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
`;
